module.exports = __webpack_public_path__ + "static/media/8.1e8ea266.png";